import dayjs from 'dayjs';
import CustomParseFormat from 'dayjs/plugin/customParseFormat';
import LoadingOverlay from '~/components/common/LoadingOverlay.vue';
import { generateMetaHead } from '~/utils/head';
import DisclosureFooter from '~/components/members-area/DisclosureFooter.vue';
dayjs.extend(CustomParseFormat);
const CONTINUE_PATH_BASE = '/members/card';
export default {
  name: 'ShopifyThankYou',
  components: {
    LoadingOverlay,
    DisclosureFooter
  },
  layout: 'members-area',
  data() {
    return {
      loaded: false,
      continueUrl: CONTINUE_PATH_BASE
    };
  },
  head() {
    return generateMetaHead({
      title: 'Create your account | Extra'
    });
  },
  computed: {},
  watch: {
    loaded(val) {
      if (!val) {
        return;
      }
      this.$analyticsHub.track('Shopify: Create account Viewed', {
        event_datetime: new Date().toISOString()
      });
    }
  },
  beforeMount() {
    // If an anonymous identifier is passed in as a query parameter
    // we will set it to the default AnalyticsHub identifier
    const {
      anonymousId
    } = this.$route.query;
    if (anonymousId) {
      this.$analyticsHub.setAnonymousId(anonymousId);
    }

    // Remove anonymousId from query parameter string, if supplied
    this.$router.replace({
      query: {
        ...this.$route.query,
        anonymousId: undefined
      }
    });
  },
  mounted() {
    // const memberPhone = this.$cookies.get('members_phone')

    this.continueUrl = CONTINUE_PATH_BASE;

    // if (memberPhone) {
    // 	this.continueUrl = CONTINUE_PATH_BASE + '?phone=' + memberPhone
    // }
  },
  methods: {
    onContinueClick(e) {
      e.preventDefault();
      this.$analyticsHub.track('Shopify: Create account Continued', {
        event_datetime: new Date().toISOString()
      });
      window.location.href = this.continueUrl;
    }
  }
};